module.exports = require("-!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./demo.vue")
module.exports.template = require("-!raw!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./demo.vue")



/*****************
 ** WEBPACK FOOTER
 ** ./demo/demo.vue
 ** module id = 4
 ** module chunks = 0
 **/